<div class="section">
  <div class="section__header">
    <h2 class="section__name">{{props['name']}}</h2>
  </div>
  <ng-container *ngIf="isAdmin()">
    <div class="section__admin-message">Administrators can select payment options not available to other users.</div>
  </ng-container>
  <div class="payment">
    <p class="payment__title">Total: {{ getTotalAmountDue() }}</p>
    <ng-container *ngIf="hasMultiplePayments$() | async">
      <div class="payment__type">
        <sl-select
            #select
            ngDefaultControl
            name="paymentType"
            label="How would you like to pay?"
            placeholder="Select pay option"
            [clearable]="true"
            (sl-change)="onSelectionChange($event)">
          <!-- Pay Now Option -->
          <ng-container *ngIf="showPayNow$() | async">
            <sl-option value="0">Pay now</sl-option>
          </ng-container>
          <!-- Invoice Option -->
          <sl-option value="1">Invoice me</sl-option>
          <!-- Offline Payment Option -->
          <ng-container *ngIf="showOfflinePayment$() | async">
            <sl-option value="3">Offline payment</sl-option>
          </ng-container>
        </sl-select>
      </div>
    </ng-container>
  </div>
  <ng-container #fieldComponent></ng-container>
</div>
